import ORM, { BaseModel } from "./orm";
import { AnalysisDimensionFilter } from "./analysis";

export interface ContextItem extends BaseModel {
    name: string;
    description?: string;
    dimension_filters: AnalysisDimensionFilter[];
}

class _ContextORM extends ORM<ContextItem> {}

export const ContextORM = new _ContextORM("contextitems");

